import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import MovieDetail from "../pages/detail/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/news/detail/page";
import ReviewList from "../pages/reviews/page";
import ReviewDetail from "../pages/reviews/detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/detail/:id",
    element: <MovieDetail />,
  },
  {
    path: "/news",
    element: <NewsList />,
  },
  {
    path: "/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/reviews",
    element: <ReviewList />,
  },
  {
    path: "/reviews/:id",
    element: <ReviewDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;